/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClaimCenterScheduleException } from './ClaimCenterScheduleException';
import {
    ClaimCenterScheduleExceptionFromJSON,
    ClaimCenterScheduleExceptionFromJSONTyped,
    ClaimCenterScheduleExceptionToJSON,
} from './ClaimCenterScheduleException';

/**
 * 
 * @export
 * @interface ClaimCenterScheduleExceptionsForRange
 */
export interface ClaimCenterScheduleExceptionsForRange {
    /**
     * 
     * @type {Array<ClaimCenterScheduleException>}
     * @memberof ClaimCenterScheduleExceptionsForRange
     */
    claimCenterExceptions: Array<ClaimCenterScheduleException>;
}

/**
 * Check if a given object implements the ClaimCenterScheduleExceptionsForRange interface.
 */
export function instanceOfClaimCenterScheduleExceptionsForRange(value: object): value is ClaimCenterScheduleExceptionsForRange {
    if (!('claimCenterExceptions' in value) || value['claimCenterExceptions'] === undefined) return false;
    return true;
}

export function ClaimCenterScheduleExceptionsForRangeFromJSON(json: any): ClaimCenterScheduleExceptionsForRange {
    return ClaimCenterScheduleExceptionsForRangeFromJSONTyped(json, false);
}

export function ClaimCenterScheduleExceptionsForRangeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimCenterScheduleExceptionsForRange {
    if (json == null) {
        return json;
    }
    return {
        
        'claimCenterExceptions': ((json['claimCenterExceptions'] as Array<any>).map(ClaimCenterScheduleExceptionFromJSON)),
    };
}

export function ClaimCenterScheduleExceptionsForRangeToJSON(value?: ClaimCenterScheduleExceptionsForRange | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'claimCenterExceptions': ((value['claimCenterExceptions'] as Array<any>).map(ClaimCenterScheduleExceptionToJSON)),
    };
}

